import { Button, TableCell, TableRow, Typography, useTheme } from '@material-ui/core';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import React, { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { pluralizeNights, _T } from '../../../../include/appI18n';
import IconText from '../../../../include/react-components/IconText';
import { formatMoney } from '../../../../include/utils';
import { toLocationHref } from '../../link-utils';
export default function TourVariantPrice(props) {
    const theme = useTheme();
    const price = useMemo(() => props.priceItem.price, [props.priceItem.price]);
    const url = useMemo(() => props.genUrl(props.tourVariant.id, props.priceItem.accomodationVariants.map(v => v.id), props.hash), [props.genUrl, props.tourVariant.id, props.priceItem.accomodationVariants, props.hash]);
    const href = useMemo(() => toLocationHref(url), [url]);
    const handleAddToCart = useCallback(() => props.book(props.tourVariant, props.priceItem.accomodationVariants, props.hash), [props.tourVariant, props.priceItem.accomodationVariants, props.book, props.hash]);
    const daysPlural = (variant) => pluralizeNights(variant.duration);
    return (React.createElement(React.Fragment, null, props.priceItem.accomodationVariants.map((v, i) => (React.createElement(TableRow, { key: i },
        React.createElement(TableCell, null,
            React.createElement(Typography, { variant: "subtitle1" }, v.hotelName),
            React.createElement(Typography, { variant: "subtitle2" },
                v.checkInDate.toDateString(),
                ", ",
                v.duration,
                " ",
                daysPlural(v))),
        React.createElement(TableCell, null, v.orderAvailability === "available"
            ? (React.createElement(IconText, { icon: React.createElement(CheckCircleOutlinedIcon, { style: { color: theme.palette.success.main }, fontSize: "small" }), text: _T.TOUR_AVAILABLE }))
            : (React.createElement(IconText, { icon: React.createElement(ContactSupportOutlinedIcon, { style: { color: theme.palette.warning.main }, fontSize: "small" }), text: _T.TOUR_ONREQUEST }))),
        React.createElement(TableCell, null,
            v.roomCategoryName,
            ", ",
            v.roomTypeName),
        React.createElement(TableCell, null, v.mealTypeName),
        i == 0 ? React.createElement(React.Fragment, null,
            React.createElement(TableCell, { rowSpan: props.priceItem.accomodationVariants.length },
                formatMoney(price, { currency: props.tour.currency.name }),
                " ",
                props.tour.currency.name),
            React.createElement(TableCell, { rowSpan: props.priceItem.accomodationVariants.length, align: "right" },
                React.createElement(Button, { color: "primary", startIcon: React.createElement(ShoppingCartOutlinedIcon, null), onClick: handleAddToCart }, _T.COMMON_BUY),
                props.forceDocumentNavigation
                    ? React.createElement("a", { href: href },
                        React.createElement(Button, { color: "secondary", startIcon: React.createElement(VisibilityOutlinedIcon, null) }, _T.COMMON_VIEW))
                    : React.createElement(Link, { to: url },
                        React.createElement(Button, { color: "secondary", startIcon: React.createElement(VisibilityOutlinedIcon, null) }, _T.COMMON_VIEW)))) : null)))));
}
